export default __webpack_public_path__ + "media/color/tnt-e31024ea.svg";